import { render, staticRenderFns } from "./Films.vue?vue&type=template&id=657c2dba&scoped=true&"
import script from "./Films.vue?vue&type=script&lang=js&"
export * from "./Films.vue?vue&type=script&lang=js&"
import style0 from "./Films.vue?vue&type=style&index=0&id=657c2dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657c2dba",
  null
  
)

export default component.exports